export default __webpack_public_path__ + "static/media/Scimitar of Red Ruin.dfe8cfa6.jpg";